module.exports = __webpack_public_path__ + "static/jd-ops-center-green-b9577efa9caa01d0d6f07d12acd51128.png";